/**
 * LTR emotion cache.
 * Used when language is English (en). Default left-to-right behavior.
 */

import createCache from '@emotion/cache';
import { prefixer } from 'stylis';

export const ltrCache = createCache({
  key: 'mui-ltr',
  stylisPlugins: [prefixer],
});
